export { default } from './MessageBoxFunctionalLayout.js';
